App.addModule(function(app) {

    app.on('loaded', () => {

        $('.product-booth-item').each(function() {
            
            var a = $(this);
            
            var delay = 300,
            	setTimeoutConst;
            
            a.popover({
                'trigger': 'manual',
                'placement': 'bottom',
                'container': 'body',
                'html': true,
                'content': $(a.attr('href'))[0].outerHTML
            });
            
            a.on('mouseenter', function() {
            	
                setTimeoutConst = setTimeout(function(){
                    
                	a.popover('show');
                	
                	$('.popover').on('mouseleave', function() {
                		a.popover('hide');
                	});
                	
                 }, delay);
                
            })
            .on('mouseleave', function() {
            	
            	clearTimeout(setTimeoutConst);
            	
                setTimeout(function () {
                    if (!$('.popover:hover').length) {
                    	a.popover('hide');
                    }
                }, delay);
                
            });
        });
    })
})
